import { useCallback, useEffect, useRef } from 'react'
import { sanitizePhoneNumber } from '~/shared/lib/utils'
import { Button } from '~/shared/ui/Buttons'
import {
  Wrapper,
  TitleWrapper,
  Title,
  Img,
  ButtonWrapper,
} from '../ErrorStep/styled'
import { Description } from './styled'

type Props = {
  phone: string
  platform: 'android' | 'ios'
}

export function ReturnToAppStep({ phone, platform }: Props) {
  const isAutoOpenedRef = useRef(false)

  const handleOpenApp = useCallback(() => {
    const sanitizedPhone = sanitizePhoneNumber(phone)
    const path = `/simplified-registration-confirm?phone=${sanitizedPhone}`

    if (platform === 'android') {
      window.location.href = `intent:/${path}#Intent;scheme=apark;package=pro.apark.driver;end`
    } else {
      window.location.href = `apark://${path}`
    }
  }, [phone, platform])

  useEffect(() => {
    // Пробуем открыть приложение автоматически сразу после успешной отправки
    // SMS-кода — переход в этот шаг происходит как следствие клика по кнопке
    // отправки формы, поэтому активация пользователя ещё действует и Chrome
    // не блокирует переход по custom scheme/intent-ссылке.
    // Кнопка ниже остаётся ручным запасным вариантом на случай, если
    // автоматический переход браузер всё же заблокировал.
    if (isAutoOpenedRef.current) {
      return
    }
    isAutoOpenedRef.current = true
    handleOpenApp()
  }, [handleOpenApp])

  return (
    <Wrapper>
      <TitleWrapper>
        <Title>SMS-код отправлен</Title>
        <Description>
          Если приложение не открылось автоматически, нажмите кнопку ниже
        </Description>
      </TitleWrapper>

      <Img src='/images/bookingCarRegister.png' alt='' />

      <ButtonWrapper>
        <Button
          fullWidth
          variant='limeFlooded'
          size='large'
          onClick={handleOpenApp}
        >
          Открыть приложение
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}
